<template lang="html">
	<div class="relative min-h-screen overflow-hidden bg-white">
		<div class="absolute inset-0 overflow-hidden pointer-events-none">
			<div
				class="absolute rounded-full -top-40 -right-40 w-80 h-80 bg-brand-navy/5 blur-3xl animate-pulse"
			></div>
			<div
				class="absolute delay-1000 rounded-full -bottom-40 -left-40 w-96 h-96 bg-brand-cyan/5 blur-3xl animate-pulse"
			></div>
		</div>

		<div class="relative z-10 py-16 lg:py-24">
			<div class="container px-6 mx-auto lg:px-8">
				<div class="pb-16 text-center">
					<div
						class="inline-flex items-center px-4 py-2 mb-6 space-x-2 text-sm font-medium tracking-wide text-primary uppercase border rounded-full bg-surface border-border"
					>
						<div
							class="w-2 h-2 bg-accent rounded-full animate-pulse"
						></div>
						<span>Get In Touch</span>
					</div>
					<h1
						class="text-4xl font-extrabold leading-tight text-text-primary md:text-5xl lg:text-6xl"
					>
						Need Support? <br />
						<span class="text-primary"> We're here to help </span>
					</h1>
					<p
						class="max-w-3xl mx-auto mt-6 text-xl leading-relaxed text-text-secondary"
					>
						Our team is ready to answer your policy questions,
						assist with claims, or help you find the right coverage.
					</p>
				</div>
				<h1
					v-if="successStatus"
					class="text-green-600 font-semibold p-2 border bg-green-50 rounded-lg w-fit text-md text-center"
				>
					{{ successStatus }}
				</h1>
				<h1
					v-if="errorStatus"
					class="text-red-600 font-semibold text-md border bg-green-50 rounded-lg w-fit text-center"
				>
					{{ errorStatus }}
				</h1>

				<div class="grid gap-12 lg:grid-cols-2">
					<div
						class="p-8 border shadow-xl bg-surface rounded-2xl border-border animate-card-float"
					>
						<div class="flex items-center mb-6 space-x-3">
							<div
								class="flex items-center justify-center flex-shrink-0 w-12 h-12 text-white bg-primary rounded-xl"
							>
								<i class="text-lg fas fa-paper-plane"></i>
							</div>
							<h2 class="text-2xl font-bold text-text-primary">
								Send us a message
							</h2>
						</div>
						<form ref="form" @submit.prevent="sendMessage">
							<div class="space-y-6">
								<div
									class="grid grid-cols-1 gap-6 sm:grid-cols-2"
								>
									<div>
										<label
											class="block text-sm font-medium text-text-primary"
											>First Name</label
										>
										<input
											type="text"
											name="firstName"
											v-model="form.firstName"
											class="w-full px-4 py-3 mt-1 border rounded-lg text-text-primary transition duration-200 focus:ring-2 focus:ring-primary focus:border-primary border-border bg-white"
											placeholder="John"
										/>
									</div>
									<div>
										<label
											class="block text-sm font-medium text-text-primary"
											>Last Name</label
										>
										<input
											type="text"
											name="lastName"
											v-model="form.lastName"
											class="w-full px-4 py-3 mt-1 border rounded-lg text-text-primary transition duration-200 focus:ring-2 focus:ring-primary focus:border-primary border-border bg-white"
											placeholder="Doe"
										/>
									</div>
								</div>

								<div>
									<label
										class="block text-sm font-medium text-text-primary"
										>Email Address</label
									>
									<input
										type="email"
										name="email"
										v-model="form.email"
										class="w-full px-4 py-3 mt-1 border rounded-lg text-text-primary transition duration-200 focus:ring-2 focus:ring-primary focus:border-primary border-border bg-white"
										placeholder="your@email.com"
									/>
								</div>

								<div>
									<label
										class="block text-sm font-medium text-text-primary"
										>Your Message</label
									>
									<textarea
										rows="4"
										name="message"
										v-model="form.message"
										class="w-full px-4 py-3 mt-1 border rounded-lg text-text-primary transition duration-200 focus:ring-2 focus:ring-primary focus:border-primary border-border bg-white"
										placeholder="Ask about a claim, policy change, or new quote."
									></textarea>
								</div>
							</div>

							<button
								@click="sendMessage"
								class="flex items-center justify-center w-full px-6 py-4 mt-6 space-x-2 text-lg font-medium text-white transition-all duration-300 rounded-lg bg-primary hover:shadow-lg hover:shadow-primary/20 hover:scale-[1.01] active:scale-95"
							>
								<span>SUBMIT INQUIRY</span>
								<i class="fas fa-arrow-right"></i>
							</button>
						</form>
					</div>

					<div
						class="p-8 border shadow-xl bg-surface rounded-2xl border-border animate-card-float flex flex-col justify-start"
						style="animation-delay: 0.1s"
					>
						<h2 class="mb-4 text-2xl font-bold text-text-primary">
							Contact Information
						</h2>
						<p class="mb-8 text-text-secondary text-base">
							For immediate assistance or to speak directly with
							an agent, please use the contact details below.
						</p>
						<div class="space-y-6 flex-grow">
							<div class="flex items-start space-x-4">
								<div
									class="flex items-center justify-center flex-shrink-0 w-12 h-12 text-white bg-primary rounded-xl"
								>
									<i
										class="text-lg fas fa-map-marker-alt"
									></i>
								</div>
								<div class="text-text-secondary">
									<h3
										class="font-semibold text-text-primary text-lg"
									>
										Office Address
									</h3>
									<p class="text-base">
										Lavington west, 42A - Nairobi, Kenya
									</p>
								</div>
							</div>
							<div class="flex items-start space-x-4">
								<div
									class="flex items-center justify-center flex-shrink-0 w-12 h-12 text-white bg-accent rounded-xl"
								>
									<i class="text-lg fas fa-phone-volume"></i>
								</div>
								<div class="text-text-secondary">
									<h3
										class="font-semibold text-text-primary text-lg"
									>
										Call Us
									</h3>
									<p class="text-base">0723 350 348</p>
								</div>
							</div>
							<div class="flex items-start space-x-4">
								<div
									class="flex items-center justify-center flex-shrink-0 w-12 h-12 text-white bg-brand-cyan rounded-xl"
								>
									<i
										class="text-lg fas fa-envelope-open-text"
									></i>
								</div>
								<div class="text-text-secondary">
									<h3
										class="font-semibold text-text-primary text-lg"
									>
										General Inquiries
									</h3>
									<p class="text-base">corporate@nexus.ke</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="mt-20">
					<div class="max-w-4xl mx-auto">
						<h2
							class="mb-8 text-3xl font-bold text-center text-text-primary"
						>
							Frequently Asked Questions
						</h2>
						<div
							class="p-8 border shadow-xl bg-surface rounded-2xl border-border animate-card-float"
							style="animation-delay: 0.3s"
						>
							<p class="mb-6 text-text-secondary">
								Find quick answers about claims, policy
								management, and coverage options for your peace
								of mind.
							</p>
							<div class="space-y-4">
								<div
									v-for="(item, index) in faqItems"
									:key="index"
									class="overflow-hidden border rounded-lg cursor-pointer transition-all duration-300 border-border hover:border-primary/50"
									:class="{
										'bg-white shadow-md':
											activeAccordion === index + 1,
									}"
									@click="openAccordion(index + 1)"
								>
									<div
										class="flex items-center justify-between p-4 transition-colors duration-200"
										:class="{
											'bg-white':
												activeAccordion === index + 1,
											'bg-surface':
												activeAccordion !== index + 1,
										}"
									>
										<div>
											<div
												class="text-sm font-semibold text-primary"
											>
												{{ item.subtitle }}
											</div>
											<div
												class="font-medium text-text-primary"
											>
												{{ item.question }}
											</div>
										</div>
										<i
											class="transition-transform duration-300 text-text-secondary"
											:class="
												activeAccordion === index + 1
													? 'fa fa-chevron-down rotate-180'
													: 'fa fa-chevron-right'
											"
										></i>
									</div>
									<transition name="accordion-slide">
										<div
											class="px-4 pb-4 text-text-secondary overflow-hidden transition-all duration-300"
											v-if="activeAccordion === index + 1"
										>
											{{ item.answer }}
										</div>
									</transition>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!--    <div class="fixed z-20 bottom-8 right-8">-->
		<!--      <button class="flex items-center justify-center text-white transition-all duration-300 transform rounded-full shadow-lg group w-14 h-14 bg-primary hover:shadow-2xl hover:shadow-primary/25 hover:scale-110 animate-float">-->
		<!--        <i class="text-lg transition-transform fas fa-headset group-hover:scale-110"></i>-->
		<!--      </button>-->
		<!--    </div>-->
	</div>
</template>

<script>
import contact from './contact.store';
import emailJs from '@emailjs/browser';
import { mapGetters, mapActions } from 'vuex';

export default {
	data() {
		return {
			activeAccordion: 0,
			faqItems: [
				{
					subtitle: 'Claims Process',
					question: 'How do I file a new insurance claim?',
					answer: "You can file a claim directly through our online client portal by navigating to the 'Claims' section, or by calling our 24/7 Claims Hotline at 0723350348. Please have your policy number ready.",
				},
				{
					subtitle: 'Policy Management',
					question: 'Can I update my coverage details online?',
					answer: 'Yes, once logged into your portal account, you can make changes to contact information, payment methods, and coverage limits (subject to underwriting approval). Changes typically take effect within 24 hours.',
				},
				{
					subtitle: 'Billing & Payments',
					question:
						'When are my insurance premiums due and how can I pay?',
					answer: "Your premium due date is listed on your policy documents and dashboard. We accept payments via credit card, mobile money (M-Pesa), or direct bank transfer, all accessible through the 'Billing' section of the portal.",
				},
			],
			form: {
				firstName: '',
				lastName: '',
				email: '',
				message: '',
			},
			successStatus: '',
			errorStatus: '',
		};
	},
	beforeDestroy() {
		this.$store.unregisterModule('contact');
	},
	created() {
		if (window.utils && window.utils.registerModule) {
			window.utils.registerModule('contact', contact, this.$store);
		}
	},
	components: {
		Form: () => import('@/libs/clarks/components/form'),
	},
	computed: {
		...mapGetters('contact', ['ContactModel', 'loading']),
	},
	methods: {
		sendMessage() {
			this.status = 'Sending...';

			emailJs
				.sendForm(
					'service_vjwqtca',
					'template_njrcqvh',
					this.$refs.form,
				)
				.then(() => {
					this.successStatus =
						"Message sent successfully! We'll get back to you soon!";
					this.form.firstName = '';
					this.form.lastName = '';
					this.form.email = '';
					this.form.message = '';
				})
				.catch((error) => {
					this.errorStatus =
						'Failed to send message. Please try again or email us directly!';
					console.error('EmailJS error:', error);
				});
		},
		openAccordion(index) {
			this.activeAccordion = this.activeAccordion === index ? 0 : index;
		},
	},
	mounted() {
		if (window.Event) {
			window.Event.$emit('loader:show', false);
		}
		emailJs.init('Hx6QvkFZ3uL4tWZQn');
	},
};
</script>

<style lang="less" scoped>
@keyframes pulse {
	0%,
	100% {
		opacity: 1;
	}
	50% {
		opacity: 0.5;
	}
}

@keyframes float {
	0%,
	100% {
		transform: translateY(0px);
	}
	50% {
		transform: translateY(-5px);
	}
}

@keyframes cardFloat {
	0% {
		transform: translateY(10px);
		opacity: 0;
	}
	100% {
		transform: translateY(0px);
		opacity: 1;
	}
}

.animate-pulse {
	animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.animate-float {
	animation: float 3s ease-in-out infinite;
}

.animate-card-float {
	animation: cardFloat 0.5s ease-out forwards;
}

.accordion-slide-enter-active,
.accordion-slide-leave-active {
	transition:
		max-height 0.3s ease-in-out,
		padding 0.3s ease-in-out;
}

.accordion-slide-enter-from,
.accordion-slide-leave-to {
	max-height: 0;
	padding-top: 0;
	padding-bottom: 0;
}

.accordion-slide-enter-to,
.accordion-slide-leave-from {
	max-height: 500px;
}

@media (max-width: 768px) {
	.container {
		padding-left: 1.5rem;
		padding-right: 1.5rem;
	}
}
</style>
